const menuItems = [
  { title: "quiz", icon: "home.png", path: "/app/quiz" },
  { title: "history", icon: "constructor.png", path: "/app/history" },
  { title: "about", icon: "data.png", path: "/app/about" },
];

export default menuItems;
